import { ReactNode } from 'react'

import { cn } from '@/utils'

const Container = ({
  children,
  className
}: {
  children: ReactNode
  className?: string
}) => {
  return <div className={cn(`container`, className)}>{children}</div>
}

export default Container
